exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tab[data-v-77df607d] {\n  padding: 0 !important;\n}\n.tab-link[data-v-77df607d] {\n  padding: 10px 30px;\n  display: block\n}\n", ""]);

// exports
